import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Modal from '../common/Modal';
import Button from '../common/Button';

const AssignAssociationToSimpleModal = ({ simple, onClose, onSuccess }) => {
  const [associations, setAssociations] = useState([]);
  const [selectedAssociation, setSelectedAssociation] = useState(
    simple.associationId?._id || ''
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchAssociations();
  }, []);

  const fetchAssociations = async () => {
    try {
      const response = await api.get('/associations');
      setAssociations(response.data.data);
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const handleAssign = async () => {
    if (!selectedAssociation) {
      alert('Veuillez sélectionner une association');
      return;
    }

    setLoading(true);
    try {
      await api.patch(`/admins/simples/${simple._id}/assign-association`, {
        associationId: selectedAssociation,
      });
      alert('Association assignée avec succès');
      onSuccess();
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur lors de l\'assignation');
    } finally {
      setLoading(false);
    }
  };

  const handleUnassign = async () => {
    if (!window.confirm('Retirer l\'association de ce Simple ?')) return;

    setLoading(true);
    try {
      await api.patch(`/simples/${simple._id}/unassign-association`);
      alert('Association retirée avec succès');
      onSuccess();
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur lors du retrait');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal title="🔗 Assigner une Association" onClose={onClose}>
      <div className="space-y-4">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
          <p className="text-sm text-blue-800">
            <strong>Simple :</strong> {simple.name}
          </p>
        </div>

        {simple.associationId && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
            <p className="text-sm text-yellow-800">
              <strong>Association actuelle :</strong>{' '}
              {simple.associationId.name || 'N/A'}
            </p>
          </div>
        )}

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Sélectionner une association
          </label>
          <select
            value={selectedAssociation}
            onChange={(e) => setSelectedAssociation(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
          >
            <option value="">-- Choisir une association --</option>
            {associations.map((assoc) => (
              <option key={assoc._id} value={assoc._id}>
                {assoc.name} ({assoc.sensorId?.name} → {assoc.switchId?.name})
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 pt-4">
          <Button onClick={handleAssign} disabled={loading} className="flex-1">
            {loading ? 'Assignation...' : 'Assigner'}
          </Button>

          {simple.associationId && (
            <Button
              variant="danger"
              onClick={handleUnassign}
              disabled={loading}
              className="flex-1"
            >
              Retirer
            </Button>
          )}

          <Button variant="secondary" onClick={onClose} className="flex-1">
            Annuler
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AssignAssociationToSimpleModal;